import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const LikeIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} viewBox="0 0 13.868 12.974">
      <g transform="translate(-31 -91)">
        <g transform="translate(31 91)">
          <g transform="translate(0 0)">
            <path
              d="M44.514,97.965a1.386,1.386,0,0,0-1.033-2.311H40.79a8.963,8.963,0,0,0,.38-2.342v-.462A1.851,1.851,0,0,0,39.321,91h-.462a.462.462,0,0,0-.448.35l-.252,1.007c-.353,1.411-1.473,2.967-2.632,3.25a1.389,1.389,0,0,0-1.29-.879H31.462a.462.462,0,0,0-.462.462v8.321a.462.462,0,0,0,.462.462h2.774a1.388,1.388,0,0,0,1.252-.79l1.588.529a5.074,5.074,0,0,0,1.608.261h3.873a1.387,1.387,0,0,0,1.289-1.9,1.386,1.386,0,0,0,.668-2.263,1.384,1.384,0,0,0,0-1.849ZM34.7,102.588a.463.463,0,0,1-.462.462H31.925v-7.4h2.311a.463.463,0,0,1,.462.462Zm7.859-4.16h.925a.462.462,0,1,1,0,.925h-.925a.462.462,0,1,0,0,.925h.925a.462.462,0,1,1,0,.925h-.925a.462.462,0,1,0,0,.925.462.462,0,0,1,0,.925H38.684a4.152,4.152,0,0,1-1.316-.214l-1.746-.582v-5.72A3.725,3.725,0,0,0,37.7,95.186a6.745,6.745,0,0,0,1.357-2.6l.164-.657h.1a.926.926,0,0,1,.925.925v.462a7.315,7.315,0,0,1-.443,2.342h-.944a.462.462,0,1,0,0,.925h4.623a.462.462,0,1,1,0,.925h-.925a.462.462,0,0,0,0,.925Z"
              transform="translate(-31 -91)"
              fill={props.color || theme.palette.primary.main}
            />
          </g>
        </g>
        <g transform="translate(32.508 100.903)">
          <g transform="translate(0 0)">
            <circle
              cx="0.5"
              cy="0.5"
              r="0.5"
              transform="translate(0.178 0.164)"
              fill={props.color || theme.palette.primary.main}
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};
